(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;

  const render = () => {
    frame = 0;
    if (reducedMotion.matches) return;

    const range = Math.max(1, Math.min(1100, document.documentElement.scrollHeight - innerHeight));
    const progress = Math.min(1, Math.max(0, scrollY / range));
    const eased = 1 - Math.pow(1 - progress, 2);

    root.style.setProperty('--mff-scroll-progress', eased.toFixed(3));
    root.style.setProperty('--mff-scroll-tint', (0.022 + eased * 0.108).toFixed(3));
    root.style.setProperty('--mff-scroll-glass', (0.62 - eased * 0.34).toFixed(3));
    root.style.setProperty('--mff-scroll-blur', `${(16 + eased * 24).toFixed(2)}px`);
    root.style.setProperty('--mff-scroll-line', (0.36 + eased * 0.39).toFixed(3));
    root.style.setProperty('--mff-scroll-shine', (0.24 + eased * 0.28).toFixed(3));
  };

  const requestRender = () => {
    if (!frame) frame = requestAnimationFrame(render);
  };

  const resetMotionPreference = () => {
    if (reducedMotion.matches) {
      root.style.removeProperty('--mff-scroll-progress');
      root.style.removeProperty('--mff-scroll-tint');
      root.style.removeProperty('--mff-scroll-glass');
      root.style.removeProperty('--mff-scroll-blur');
      root.style.removeProperty('--mff-scroll-line');
      root.style.removeProperty('--mff-scroll-shine');
    }
    requestRender();
  };

  render();
  addEventListener('scroll', requestRender, { passive: true });
  addEventListener('resize', requestRender, { passive: true });
  reducedMotion.addEventListener?.('change', resetMotionPreference);
})();
